import FeatureSwitchManager from 'common/services/FeatureSwitchManager';
import { getUrlParam } from 'common/utils/urlManipulation';

export const setupFeatureSwitchManagerFromURI = () => {
  const params = getUrlParam();
  if (params.youbora) {
    FeatureSwitchManager.set(
      ['Player', 'Youbora'],
      window.location.search.includes('youbora=1')
        ? FeatureSwitchManager.ENABLE_VALUE
        : FeatureSwitchManager.DEFAULT_VALUE
    );
  }
  if (params.mockAd) {
    const mode = params.mockAd;
    FeatureSwitchManager.set(
      ['Ad', 'MockUrl'],
      FeatureSwitchManager.AD_MOCK_LIST[mode] || FeatureSwitchManager.DEFAULT_VALUE
    );
  }
  if (params.playerInfo) {
    FeatureSwitchManager.set(
      ['Player', 'Info'],
      window.location.search.includes('playerInfo=1')
        ? FeatureSwitchManager.ENABLE_VALUE
        : FeatureSwitchManager.DEFAULT_VALUE
    );
  }
};
